import { type PrinterOptions } from "qz-tray";
import { useSyncExternalStore } from "use-sync-external-store/shim";

import { qz } from "../client";
import {
  getConfigDefaultsSnapshot,
  setConfigDefaults,
  subscribeConfigDefaults,
} from "./state";
import { type QZConfigInstance, type QZConfigPrinterInput } from "./types";

export const createConfig = (
  printer: QZConfigPrinterInput,
  options?: PrinterOptions,
): QZConfigInstance =>
  qz.configs.create(printer, options) as unknown as QZConfigInstance;

export const useConfigDefaults = () =>
  useSyncExternalStore(subscribeConfigDefaults, getConfigDefaultsSnapshot);

export const useQZConfigs = () => {
  const state = useConfigDefaults();
  return { ...state, createConfig, setConfigDefaults };
};
